import {TypographySize, useTypography} from '../../hooks/typography';

import {type LinkSize, type LinkVariant} from './link';

export const useLinkTypography = (size: LinkSize, variant: LinkVariant) => {
    const boldFont = variant === 'flat';
    const [
        bodySTypography,
        bodyMTypography,
        bodyLTypography,
    ] = useTypography([
        {size: boldFont ? TypographySize.BodySTrue : TypographySize.BodyS},
        {size: boldFont ? TypographySize.BodyMTrue : TypographySize.BodyM},
        {size: boldFont ? TypographySize.BodyLTrue : TypographySize.BodyL},
    ]);
    switch (size) {
    case 'small':
        return bodySTypography;
    case 'medium':
        return bodyMTypography;
    case 'large':
        return bodyLTypography;
    }
};
